import { langId } from "@escapio/shared/l10n/lang-id";

const formatterMap = {};

export const getFormatter = (currency, decimals = 0) => {
	const key = `${currency}-${decimals}`;
	let formatter = formatterMap[key];
	if (!formatter) {
		const round = n => (decimals === 0 ? Math.floor(n) : n);
		const numberFormat = new Intl.NumberFormat(langId, {
			style: "currency",
			currency,
			minimumFractionDigits: decimals,
			maximumFractionDigits: decimals,
		});

		formatter = value => numberFormat.format(round(value));

		formatterMap[key] = formatter;
	}

	return formatter;
};
